import type { FC, ReactNode } from 'react';

import { SectionHeaderCenter, SectionHeaderLeft, SectionHeaderRight } from './components';
import { useViewMode } from '../../../store/app/appStore';

import styles from './SectionHeader.module.css';

interface HeaderProps {
  children: ReactNode;
}

interface SectionHeaderComponent extends FC<HeaderProps> {
  Center: typeof SectionHeaderCenter;
  Left: typeof SectionHeaderLeft;
  Right: typeof SectionHeaderRight;
}

const SectionHeader: SectionHeaderComponent = ({ children }) => {
  const viewMode = useViewMode();

  return (
    <div data-view={viewMode} className={styles.sectionHeader}>
      {children}
    </div>
  );
};

SectionHeader.Center = SectionHeaderCenter;
SectionHeader.Left = SectionHeaderLeft;
SectionHeader.Right = SectionHeaderRight;

export default SectionHeader;
